import findIndex from 'lodash/findIndex';

export default (state = {}, action = {}) => {
  switch(action.type) {
    case 'FETCH_LINKS':
      if(action.payload.links.length>0){
        return {
          ...state,
          [action.payload.order_id]: action.payload.links
        }
      }
      else{
        return {
          ...state,
          [action.payload.order_id]: []
        }
      }
    case 'EDIT_LINK':
      const index = findIndex(state[action.payload.link_order_id],
        { link_id: action.payload.link_id });
      if (index >= 0) {
        return {
          ...state,
          [action.payload.link_order_id]:[
            ...state[action.payload.link_order_id].slice(0, index),
            action.payload,
            ...state[action.payload.link_order_id].slice(index + 1)
          ]
        }
      }
      return state;
    case 'CREATE_LINK':
      return {
        ...state,
        [action.payload.link_order_id]:[
          ...state[action.payload.link_order_id],
          action.payload
        ]
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/links.js